import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../../Components/ErrorContainer";
import { getFormData } from "../../../../helpers";
import SingleSearchSelect from "../../../Components/SingleSearchSelect";
import ModelContainer from "../../../Components/ModelContainer";

const NewPayee = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const pageType = params?.location?.state?.type;

  const [linkedAccount, setLinkedAccount] = useState("");
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (pageType === "edit")
      dispatch(actions.getPayeeEditData({ id: params?.location?.state?.id }));
    else {
      dispatch(actions?.getAddPayeeData());
    }
  }, []);

  const addEditPayeeData = useSelector(
    (state) => state?.orderInvoicesReducer?.addEditPayeeData
  );

  useEffect(() => {
    if (pageType === "edit") {
      console.log("lllllllllllllll", pageType);
      const selectedData = addEditPayeeData?.expense_account?.find(
        (el) => el?.value == addEditPayeeData?.payee?.expense_id
      );
      setSelected(selectedData ? [selectedData] : []);
    }
  }, [addEditPayeeData]);

  const defaultAddEditValues = {
    linked_account:
      pageType === "edit" ? addEditPayeeData?.payee?.linked_account : "",
    expense_group_id:
      pageType === "edit" ? addEditPayeeData?.payee?.expense_group_id : "",
    expense_id: pageType === "edit" ? addEditPayeeData?.payee?.expense_id : "",
    payee_name: pageType === "edit" ? addEditPayeeData?.payee?.payee_name : "",
    contact_name:
      pageType === "edit" ? addEditPayeeData?.payee?.contact_name : "",
    addressInfo_address_line_1:
      pageType === "edit"
        ? addEditPayeeData?.payee?.contact_address_line_1
        : "",
    addressInfo_address_line_2:
      pageType === "edit"
        ? addEditPayeeData?.payee?.contact_address_line_2
        : "",
    addressInfo_country:
      pageType === "edit" ? addEditPayeeData?.payee?.contact_country : "",
    addressInfo_state:
      pageType === "edit" ? addEditPayeeData?.payee?.contact_state : "",
    addressInfo_city:
      pageType === "edit" ? addEditPayeeData?.payee?.contact_city : "",
    addressInfo_zip_code:
      pageType === "edit" ? addEditPayeeData?.payee?.contact_zip_code : "",
    linked_account_name:
      pageType === "edit" ? addEditPayeeData?.payee?.linked_account_name : "",

    contact_number_1:
      pageType === "edit" ? addEditPayeeData?.payee?.contact_number_1 : "",
    contact_number_2:
      pageType === "edit" ? addEditPayeeData?.payee?.contact_number_2 : "",
    email: pageType === "edit" ? addEditPayeeData?.payee?.email : "",
    uen_number: pageType === "edit" ? addEditPayeeData?.payee?.uen_number : "",
    billingAddress_address_line_1:
      pageType === "edit" ? addEditPayeeData?.payee?.billing_address_1 : "",
    billingAddress_address_line_2:
      pageType === "edit" ? addEditPayeeData?.payee?.billing_address_2 : "",
    billingAddress_country:
      pageType === "edit" ? addEditPayeeData?.payee?.billing_country : "",
    billingAddress_state:
      pageType === "edit" ? addEditPayeeData?.payee?.billing_state : "",
    billingAddress_city:
      pageType === "edit" ? addEditPayeeData?.payee?.billing_city : "",
    billingAddress_zip_code:
      pageType === "edit" ? addEditPayeeData?.payee?.billing_zip_code : "",
    credit_terms_type:
      pageType === "edit" ? addEditPayeeData?.payee?.credit_terms_type : "",
    credit_terms_days:
      pageType === "edit" ? addEditPayeeData?.payee?.credit_terms_days : "",
    credit_terms_value:
      pageType === "edit" ? addEditPayeeData?.payee?.credit_terms_value : "",
    default_payment_act:
      pageType === "edit" ? addEditPayeeData?.payee?.default_payment_act : "",
    interest_rate:
      pageType === "edit" ? addEditPayeeData?.payee?.interest_rate : "",
    minimum_order_value:
      pageType === "edit" ? addEditPayeeData?.payee?.minimum_order_value : "",
    tax_charged:
      pageType === "edit" ? addEditPayeeData?.payee?.tax_charged : "",
  };
  useEffect(() => {
    if (pageType === "edit") reset(defaultAddEditValues);
  }, [pageType, addEditPayeeData]);
  const schema = yup.object().shape({
    linked_account: yup.string().required(),
    expense_group_id: yup.string().required(),
    expense_id: yup.string().required(),
    payee_name: yup.string().required(),
    contact_name: yup.string().required(),
    addressInfo_address_line_1: yup.string().required(),
    addressInfo_address_line_2: yup.string(),
    addressInfo_country: yup.string().required(),
    addressInfo_state: yup.string().required(),
    addressInfo_city: yup.string().required(),
    addressInfo_zip_code: yup.string().required(),
    linked_account_name:
      linkedAccount === "yes"
        ? yup.string().required()
        : yup.string().nullable(),
    contact_number_1: yup.string().required(),
    contact_number_2: yup.string(),
    email: yup.string(),
    uen_number: yup.string(),
    billingAddress_address_line_1: yup.string().required(),
    billingAddress_address_line_2: yup.string(),
    billingAddress_country: yup.string().required(),
    billingAddress_state: yup.string().required(),
    billingAddress_city: yup.string().required(),
    billingAddress_zip_code: yup.string().required(),
    credit_terms_type: yup.string(),
    credit_terms_days: yup.string(),
    credit_terms_value: yup.string(),
    default_payment_act: yup.string().required(),
    interest_rate: yup.string().required(),
    minimum_order_value: yup.string(),
    tax_charged: yup.string(),
  });
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    // defaultValues: addEditDefaultValue,
  });
  function submitData(data) {
    const finalData = {
      linked_account: data?.linked_account,
      expense_group_id: data?.expense_group_id,
      expense_id: data?.expense_id,
      payee_name: data?.payee_name,
      contact_name: data?.contact_name,
      addressInfo: {
        address_line_1: data?.addressInfo_address_line_1,
        address_line_2: data?.addressInfo_address_line_2,
        country: data?.addressInfo_country,
        state: data?.addressInfo_state,
        city: data?.addressInfo_city,
        zip_code: data?.addressInfo_zip_code,
      },
      linked_account_name: data?.linked_account_name,
      contact_number_1: data?.contact_number_1,
      contact_number_2: data?.contact_number_2,
      email: data?.email,
      uen_number: data?.uen_number,
      billingAddress: {
        address_line_1: data?.billingAddress_address_line_1,
        address_line_2: data?.billingAddress_address_line_2,
        country: data?.billingAddress_country,
        state: data?.billingAddress_state,
        city: data?.billingAddress_city,
        zip_code: data?.billingAddress_zip_code,
      },
      credit_terms_type: data?.credit_terms_type,
      credit_terms_days: data?.credit_terms_days,
      credit_terms_value: data?.credit_terms_value,
      interest_rate: data?.interest_rate,
      default_payment_act: data?.default_payment_act,
      minimum_order_value: data?.minimum_order_value,
      tax_charged: data?.tax_charged,
    };
    if (pageType === "edit")
      dispatch(
        actions.postPayeeEditData({
          data: { id: addEditPayeeData.payee.id, ...finalData },
          history: history,
        })
      );
    else {
      dispatch(actions.postAddPayeeData({ data: finalData, history: history }));
    }
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 new-payee">
          <div className="container px-0">
            <form onSubmit={handleSubmit(submitData)}>
              <div class="row">
                <div className="col-lg-8">
                  <div className="shadowclass my-lg-4 my-2">
                    <h4 class="event-alert"> Payee Info </h4>
                    <div class="row mx-0">
                      <div class="col-md-12 d-flex payee_info px-sm-2 px-0">
                        <ul class="ingredient-info d-flex col-xl-6 col-12">
                          <Select
                            label={"Linked Account?"}
                            formRegister={register}
                            formError={errors}
                            formKey={"linked_account"}
                            onChange={(e) => {
                              setLinkedAccount(e.target.value);
                              dispatch(actions?.getPayeeLinkedEmployee());
                            }}
                            optionsArray={addEditPayeeData?.yes_no}
                          />

                          <Select
                            label={"Payee Category"}
                            formRegister={register}
                            formError={errors}
                            formKey={"expense_group_id"}
                            onChange={(e) => {
                              dispatch(
                                actions?.getPayeeExpenseAccount({
                                  id: e.target.value,
                                  type: pageType,
                                })
                              );
                            }}
                            optionsArray={addEditPayeeData?.expenseGroupList}
                          />
                          <SingleSearchSelect
                            label={"Default Expense/Asset Account"}
                            formRegister={register}
                            formError={errors}
                            formKey={"expense_id"}
                            selected={selected}
                            setSelected={setSelected}
                            options={addEditPayeeData?.expense_account}
                            setValue={setValue}
                          />

                          <Input
                            label={"Payee Name"}
                            formRegister={register}
                            formError={errors}
                            formKey={"payee_name"}
                          />
                          <Input
                            label={"Contact Name"}
                            formRegister={register}
                            formError={errors}
                            formKey={"contact_name"}
                          />
                        </ul>

                        <ul class="ingredient-info d-flex col-xl-6 col-12 justify-content-end">
                          {linkedAccount === "yes" && (
                            <Select
                              label={"Linked Acct Name"}
                              formRegister={register}
                              formError={errors}
                              formKey={"linked_account_name"}
                              optionsArray={addEditPayeeData?.employees}
                            />
                          )}
                          <Input
                            label={"Contact Number #1"}
                            formRegister={register}
                            formError={errors}
                            formKey={"contact_number_1"}
                          />
                          <Input
                            label={"Contact Number #2"}
                            formRegister={register}
                            formError={errors}
                            formKey={"contact_number_2"}
                          />
                          <Input
                            label={"Email"}
                            formRegister={register}
                            formError={errors}
                            formKey={"email"}
                          />
                          <Input
                            label={"UEN Number"}
                            formRegister={register}
                            formError={errors}
                            formKey={"uen_number"}
                          />
                        </ul>
                      </div>

                      <div class="col-md-12 d-flex address_copy px-sm-2 px-0">
                        <ul class="ingredient-info d-flex col-xl-6 col-sm-6 col-12 mb-5 mb-sm-0">
                          <li class="list-heading-bottom">
                            {" "}
                            <label> Contact Address </label>{" "}
                          </li>
                          <Input
                            label={"Address Line #1"}
                            formRegister={register}
                            formError={errors}
                            formKey={"addressInfo_address_line_1"}
                          />
                          <Input
                            label={"Address Line #2"}
                            formRegister={register}
                            formError={errors}
                            formKey={"addressInfo_address_line_2"}
                          />
                          <Select
                            label={"Country"}
                            onChange={(e) => {
                              dispatch(
                                actions?.getPayeeContactStates({
                                  id: e.target.value,
                                  formType: pageType,
                                })
                              );
                            }}
                            formRegister={register}
                            formError={errors}
                            formKey={"addressInfo_country"}
                            optionsArray={addEditPayeeData?.countries}
                          />
                          <Select
                            label={"State"}
                            formRegister={register}
                            formError={errors}
                            formKey={"addressInfo_state"}
                            optionsArray={addEditPayeeData?.address_states}
                          />
                          <Input
                            label={"City"}
                            formRegister={register}
                            formError={errors}
                            formKey={"addressInfo_city"}
                          />
                          <Input
                            label={"Zip Code"}
                            formRegister={register}
                            formError={errors}
                            formKey={"addressInfo_zip_code"}
                          />
                        </ul>
                        <a href="javascript:void(0)" class="image_arrow"></a>
                        <ul class="ingredient-info d-flex col-xl-6 col-sm-6 col-12 justify-content-end">
                          <li class="list-heading-bottom col-xl-6 col-12">
                            {" "}
                            <label> Billing Address</label>{" "}
                          </li>

                          <Input
                            label={"Address Line #1"}
                            formRegister={register}
                            formError={errors}
                            formKey={"billingAddress_address_line_1"}
                          />
                          <Input
                            label={"Address Line #2"}
                            formRegister={register}
                            formError={errors}
                            formKey={"billingAddress_address_line_2"}
                          />
                          <Select
                            label={"Country"}
                            onChange={(e) => {
                              dispatch(
                                actions?.getPayeeBillingStates({
                                  id: e.target.value,
                                  formType: pageType,
                                })
                              );
                            }}
                            formRegister={register}
                            formError={errors}
                            formKey={"billingAddress_country"}
                            optionsArray={addEditPayeeData?.countries}
                          />
                          <Select
                            label={"State"}
                            formRegister={register}
                            formError={errors}
                            formKey={"billingAddress_state"}
                            optionsArray={addEditPayeeData?.billing_states}
                          />
                          <Input
                            label={"City"}
                            formRegister={register}
                            formError={errors}
                            formKey={"billingAddress_city"}
                          />
                          <Input
                            label={"Zip Code"}
                            formRegister={register}
                            formError={errors}
                            formKey={"billingAddress_zip_code"}
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 row mx-0">
                  <div class="shadowclass my-lg-4 my-2 paymentTerms">
                    <h4 class="event-alert">Payment Terms</h4>
                    <div class="row mx-0">
                      <div class="col-md-12 d-flex payee_info px-sm-2 px-0">
                        <ul class="ingredient-info d-flex col-12">
                          <li>
                            <label class="">Credit Terms</label>
                            <div class="input-group select-div">
                              <select
                                {...register("credit_terms_type")}
                                class="required"
                              >
                                <option value="">Select Credit Term</option>
                                <option value="1">COD</option>
                                <option value="2">30 Days</option>
                                <option value="3">60 Days</option>
                                <option value="4">90 Days</option>
                                <option value="5">Other Credit Term</option>
                                <option value="6">7 Days</option>
                                <option value="7">14 Days</option>
                                <option value="8">15 Days</option>
                                <option value="9">TT in Advance</option>
                              </select>
                            </div>
                          </li>
                          <Input
                            label={"Interest Rate"}
                            formRegister={register}
                            formError={errors}
                            formKey={"interest_rate"}
                          />
                          <Select
                            label={"Default Payment Acct."}
                            formRegister={register}
                            formError={errors}
                            formKey={"default_payment_act"}
                            optionsArray={addEditPayeeData?.subAccounts}
                          />
                          <Input
                            label={"Minimum Order Value"}
                            formRegister={register}
                            formError={errors}
                            formKey={"minimum_order_value"}
                          />

                          <Input
                            label={"Tax Charged"}
                            formRegister={register}
                            formError={errors}
                            formKey={"tax_charged"}
                          />
                        </ul>
                      </div>
                      <RecurringPayments
                        id={params?.location?.state?.id}
                        pageType={params?.location?.state?.type}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <BankingInfo
                  id={params?.location?.state?.id}
                  pageType={params?.location?.state?.type}
                />

                <Documents
                  id={params?.location?.state?.id}
                  pageType={params?.location?.state?.type}
                />
              </div>

              <div class="row mx-0">
                <div class="container px-0 d-flex col-12">
                  <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                    <button type="submit">Save</button>
                    <button
                      onClick={() => history.push("/order/payees/")}
                      id="cancel"
                      type="button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0"> History </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-lg-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th> Start </th>
                                <th>End</th>
                                <th>Field</th>
                                <th>Value</th>
                                <th>Replacement Value</th>
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

const RecurringPayments = ({ id, pageType }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const recurringModal = useSelector(
    (state) => state?.orderInvoicesReducer?.recurringPaymentsModal
  );
  const setRecurringModal = (modalState) =>
    dispatch(
      actions.setModalState({
        modalName: "recurringPaymentsModal",
        modalState: modalState,
      })
    );
  const [modalDetails, setModalDetails] = useState({ type: "add", key: null });
  const [frequency, setFrequency] = useState("");
  const [monthly, setMonthly] = useState("");
  const [selectedWeeks, setSelectedWeeks] = useState([]);

  // useEffect(() => {
  //   if (pageType === "edit") {
  //     dispatch(actions.getPayeePaymentInfoOptions({ id: id }));
  //     dispatch(actions.getPayeePaymentInfoData());
  //   }
  //   return () =>
  //     dispatch(
  //       actions.saveOrderInvoicesValue({
  //         payeePaymentInfoData: null,
  //       })
  //     );
  // }, []);

  const addEditPayeeData = useSelector(
    (state) => state?.orderInvoicesReducer?.addEditPayeeData
  );

  const defaultAddEditValues = {
    frequency: "",
    daily: "",
    weekly: "",
    monthly: "",
    mdom: "",
    amount: "",
    payment_method: "",
    transaction_description: "",
  };

  const schema = yup.object().shape({
    frequency: yup.string().required(),
    daily: frequency === "daily" ? yup.string().required() : yup.string(),
    weekly: frequency === "weekly" ? yup.array().required() : yup.string(),
    monthly: frequency === "monthly" ? yup.string().required() : yup.string(),
    mdom: monthly === "mdom" ? yup.string().required() : yup.string(),
    amount: yup.string().required(),
    payment_method: yup.string().required(),
    transaction_description: yup.string().required(),
  });
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  function submitData(data) {
    if (modalDetails.type === "edit")
      dispatch(
        actions?.postPayeePaymentInfoData({ ...data, key: modalDetails?.key })
      );
    else dispatch(actions?.postPayeePaymentInfoData(data));
  }

  function setEditValues(key) {
    const editModalData = addEditPayeeData?.payments_table?.find(
      (el) => el.key === key
    );
    reset(editModalData);
  }
  return (
    <>
      <div class="col-md-12 d-flex payee_info px-sm-2 px-0">
        <div class="pay-note mt-3 mt-sm-5 col-12">
          <div class="col-12">
            <h4 class="event-alert">Recurring Payments</h4>
            <div class="inner-space screen-scroll mCS_destroyed">
              <table
                id="TableDable"
                class="checklist-table remove-space"
                width="100%"
                cellspacing="0"
                cellpadding="0"
              >
                <thead>
                  <tr>
                    <th>Frequency</th>
                    <th>Amount</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody id="paymentIndex">
                  {addEditPayeeData?.payments_table?.map((el) => (
                    <tr>
                      <td>{el?.frequency}</td>
                      <td>{el?.amount}</td>
                      <td>
                        <div class="event-time-edit p0">
                          <a
                            onClick={() => {
                              setModalDetails({ type: "edit", key: el?.key });
                              setRecurringModal(true);
                              setEditValues(el?.key);
                            }}
                            class="editPayment"
                            val="0"
                          >
                            <i class="iconSprites edit-icon"></i>
                          </a>
                          <a
                            onClick={() => {
                              dispatch(
                                actions?.postDeletePayeePaymentInfoData({
                                  key: el.key,
                                })
                              );
                            }}
                            class="deletePayment"
                            val="0"
                          >
                            <i class="iconSprites delete-icon"></i>
                          </a>
                          <span></span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div class="check-list-nav">
                <button
                  onClick={() => {
                    reset(defaultAddEditValues);
                    setRecurringModal(true);
                    setModalDetails({ type: "add", key: null });
                  }}
                  class="btn green-btn-revert add-plus addSp mx-0"
                  id="addCount"
                  type="button"
                >
                  <i class="i-icon"> </i> Add Recurring Payments{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModelContainer
        title="Add Recurring Payment"
        open={recurringModal}
        closeModal={() => setRecurringModal(false)}
        submitModal={handleSubmit(submitData)}
      >
        <form>
          <div className="form-list">
            <ul className="px-0">
              <Select
                onChange={(e) => {
                  setFrequency(e.target.value);
                }}
                label={"Frequency"}
                formRegister={register}
                formError={errors}
                formKey={"frequency"}
                optionsArray={addEditPayeeData?.recurrence}
              />
              {frequency === "daily" && (
                <Select
                  label={"Daily"}
                  formRegister={register}
                  formError={errors}
                  formKey={"daily"}
                  optionsArray={addEditPayeeData?.daily}
                />
              )}
              {frequency === "weekly" && (
                <li>
                  <label className={"required"}>Weekly</label>
                  <div class={`select-div input-group `}>
                    <MultiSelect
                      {...register("weekly")}
                      value={selectedWeeks}
                      onChange={(arr) => {
                        setSelectedWeeks(arr);
                        const res = arr;
                        setValue(
                          "weekly",
                          arr.map((el) => el.value)
                        );
                      }}
                      labelledBy="Promo Code"
                      showCheckbox={true}
                      options={
                        addEditPayeeData?.weekly?.map((el) => ({
                          value: el,
                          label: el,
                        })) ?? []
                      }
                    />
                    {<ErrorContainer errors={errors} name={"weekly"} />}
                  </div>
                </li>
              )}
              {frequency === "monthly" && (
                <Select
                  onClick={(e) => setMonthly(e.target.value)}
                  label={"Monthly"}
                  formRegister={register}
                  formError={errors}
                  formKey={"monthly"}
                  optionsArray={addEditPayeeData?.monthly}
                />
              )}
              {monthly === "mdom" && (
                <Select
                  label={"Day of month"}
                  formRegister={register}
                  formError={errors}
                  formKey={"mdom"}
                  optionsArray={addEditPayeeData?.mdom}
                />
              )}
              <Input
                label={"Amount"}
                formRegister={register}
                formError={errors}
                formKey={"amount"}
              />
              <Select
                label={"Default Payment Account"}
                formRegister={register}
                formError={errors}
                formKey={"payment_method"}
                optionsArray={addEditPayeeData?.subAccounts}
              />
              <Input
                label={"Transaction Decsription"}
                formRegister={register}
                formError={errors}
                formKey={"transaction_description"}
              />
            </ul>
          </div>
        </form>
      </ModelContainer>
    </>
  );
};

const Documents = ({ id, pageType }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const addEditPayeeData = useSelector(
    (state) => state?.orderInvoicesReducer?.addEditPayeeData
  );
  const documentModal = useSelector(
    (state) => state?.orderInvoicesReducer?.payeeDocumentModal
  );
  const setDocumentModal = (modalState) =>
    dispatch(
      actions.setModalState({
        modalName: "payeeDocumentModal",
        modalState: modalState,
      })
    );
  const [modalDetails, setModalDetails] = useState({ type: "add", key: null });

  // useEffect(() => {
  //   if (pageType === "edit") {
  //     dispatch(actions.getPayeeDocumentData());
  //   }
  //   return () =>
  //     dispatch(
  //       actions.saveOrderInvoicesValue({
  //         payeeDocumentData: null,
  //       })
  //     );
  // }, []);

  const defaultAddEditValues = {
    document_name: "",
    document: "",
  };

  const schema = yup.object().shape({
    document_name: yup.string().required(),
    document: yup.mixed().required(),
  });
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultAddEditValues,
  });

  function submitData(data) {
    if (modalDetails.type === "add") {
      dispatch(
        actions?.postPayeeDocumentData(
          getFormData({ ...data, document: data?.document[0] })
        )
      );
    } else
      dispatch(
        actions?.postPayeeDocumentData(
          getFormData({
            ...data,
            document: data?.document[0],
            key: modalDetails?.key,
          })
        )
      );
  }

  function setEditValues(key) {
    const editModalData = addEditPayeeData?.documents_table?.find(
      (el) => el.key === key
    );
    reset(editModalData);
  }
  return (
    <>
      <div class="col-lg-4 row mx-0">
        <div class="shadowclass my-lg-4 my-2 paymentTerms">
          <h4 class="event-alert">Document Payments</h4>
          <div class="row mx-sm-0">
            <div class="table-responsive">
              <table
                id="TableDable"
                class="checklist-table inventory_table"
                width="100%"
                cellspacing="0"
                cellpadding="0"
              >
                <thead>
                  <tr>
                    <th>Document Name</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody id="paymentIndex">
                  {addEditPayeeData?.documents_table?.map((el) => (
                    <tr>
                      <td>{el?.document_name}</td>
                      <td>{el?.date}</td>
                      <td>
                        <div class="event-time-edit p0">
                          <a
                            onClick={() => {
                              setModalDetails({ type: "edit", key: el?.key });
                              setDocumentModal(true);
                              setEditValues(el?.key);
                            }}
                            class="editPayment"
                            val="0"
                          >
                            <i class="iconSprites edit-icon"></i>
                          </a>
                          <a
                            onClick={() => {
                              dispatch(
                                actions?.deletePayeeDocumentData({
                                  key: el.key,
                                })
                              );
                            }}
                            class="deletePayment"
                            val="0"
                          >
                            <i class="iconSprites delete-icon"></i>
                          </a>
                          <span></span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div class="check-list-nav">
                <button
                  onClick={() => {
                    reset(defaultAddEditValues);
                    setDocumentModal(true);
                    setModalDetails({ type: "add", key: null });
                  }}
                  class="btn green-btn-revert add-plus addSp mx-0"
                  id="addCount"
                  type="button"
                >
                  <i class="i-icon"> </i> Add Document{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModelContainer
        title="Add Document Payment"
        open={documentModal}
        closeModal={() => setDocumentModal(false)}
        submitModal={handleSubmit(submitData)}
      >
        <form>
          <div className="form-list">
            <ul className="px-0">
              <Input
                label={"Document Name"}
                formRegister={register}
                formError={errors}
                formKey={"document_name"}
              />
              <Input
                label={"Document"}
                type="file"
                formRegister={register}
                formError={errors}
                formKey={"document"}
              />
            </ul>
          </div>
        </form>
      </ModelContainer>
    </>
  );
};

const BankingInfo = ({ id, pageType }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const bankingInfoModal = useSelector(
    (state) => state?.orderInvoicesReducer?.payeeBankingInfoModal
  );
  const setBankingInfoModal = (modalState) =>
    dispatch(
      actions.setModalState({
        modalName: "payeeBankingInfoModal",
        modalState: modalState,
      })
    );
  const [modalDetails, setModalDetails] = useState({ type: "add", key: null });

  const addEditPayeeData = useSelector(
    (state) => state?.orderInvoicesReducer?.addEditPayeeData
  );

  // useEffect(() => {
  //   if (pageType === "edit") {
  //     dispatch(actions.getPayeeBankingInfoData());
  //   }
  //   return () =>
  //     dispatch(
  //       actions.saveOrderInvoicesValue({
  //         payeeBankingInfoData: null,
  //       })
  //     );
  // }, []);

  const defaultAddEditValues = {
    document_name: "",
    document: "",
  };

  const schema = yup.object().shape({
    bank_name: yup.string().required(),
    account: yup.string().required(),
    routing: yup.string().required(),
    is_primary: yup.string().required(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultAddEditValues,
  });

  function submitData(data) {
    if (modalDetails.type === "add") {
      dispatch(actions?.postPayeeBankingInfoData(data));
    } else
      dispatch(
        actions?.postPayeeBankingInfoData({
          ...data,
          key: modalDetails?.key,
        })
      );
  }

  function setEditValues(key) {
    const editModalData = addEditPayeeData?.employees_table?.find(
      (el) => el.key === key
    );
    reset(editModalData);
  }
  return (
    <>
      <div class="col-lg-8">
        <div class="shadowclass my-lg-4 my-2">
          <h4 class="event-alert">Banking Info</h4>
          <div class="row mx-sm-0">
            <div class="table-responsive">
              <table
                id="TableDable"
                class="checklist-table inventory_table"
                width="100%"
                cellspacing="0"
                cellpadding="0"
              >
                <thead>
                  <tr>
                    <th className="min-wd-150">Banking Name</th>
                    <th>Account #</th>
                    <th>Routing #</th>
                    <th>Primary?</th>
                  </tr>
                </thead>
                <tbody id="paymentIndex">
                  {addEditPayeeData?.employees_table?.map((el) => (
                    <tr>
                      <td>{el?.bank_name}</td>
                      <td>{el?.account}</td>
                      <td>{el?.routing}</td>
                      <td>{el?.is_primary}</td>
                      <td>
                        <div class="event-time-edit p0">
                          <a
                            onClick={() => {
                              setModalDetails({ type: "edit", key: el?.key });
                              setBankingInfoModal(true);
                              setEditValues(el?.key);
                            }}
                            class="editPayment"
                            val="0"
                          >
                            <i class="iconSprites edit-icon"></i>
                          </a>
                          <a
                            onClick={() => {
                              dispatch(
                                actions?.deletePayeeBankingInfoData({
                                  key: el.key,
                                })
                              );
                            }}
                            class="deletePayment"
                            val="0"
                          >
                            <i class="iconSprites delete-icon"></i>
                          </a>
                          <span></span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div class="check-list-nav">
                <button
                  onClick={() => {
                    reset(defaultAddEditValues);
                    setBankingInfoModal(true);
                    setModalDetails({ type: "add", key: null });
                  }}
                  class="btn green-btn-revert add-plus addSp mx-0"
                  id="addCount"
                  type="button"
                >
                  <i class="i-icon"> </i> Add Banking Info
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModelContainer
        title="Add Banking Info"
        open={bankingInfoModal}
        closeModal={() => setBankingInfoModal(false)}
        submitModal={handleSubmit(submitData)}
      >
        <form>
          <div className="form-list">
            <ul className="px-0">
              <Select
                label={"Bank Name"}
                formRegister={register}
                formError={errors}
                formKey={"bank_name"}
                optionsArray={addEditPayeeData?.banks}
              />
              <Input
                label={"Account #"}
                formRegister={register}
                formError={errors}
                formKey={"account"}
              />
              <Input
                label={"Routing #"}
                formRegister={register}
                formError={errors}
                formKey={"routing"}
              />
              <Input
                label={"Primary?"}
                formRegister={register}
                formError={errors}
                formKey={"is_primary"}
              />
            </ul>
          </div>
        </form>
      </ModelContainer>
    </>
  );
};
export default NewPayee;
